import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import InnerHTML from 'dangerously-set-html-content';

export default function CustomComponent({ component }) {
	const { content } = component;
	useEffect(() => {}, [content]);

	return <InnerHTML html={content} />;
}

CustomComponent.propTypes = {
	component: PropTypes.object,
};
